import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Dialog, Stack } from '@mui/material'
import { useTranslation } from 'react-i18next'

import ModalHeader from 'components/global/Modals/ModalHeader'

import { IEventSsid } from '../use-event-ssids'

interface IModalProps {
  item: IEventSsid | null
  children: React.ReactNode
  onClose?: () => void
}

const Modal: React.FC<IModalProps> = ({ item, children, onClose }) => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const handleClose = () => {
    if (onClose) {
      onClose()
    } else {
      navigate('..')
    }
  }

  return (
    <Dialog
      style={{ backgroundColor: 'transparent' }}
      maxWidth='md'
      PaperProps={{
        style: {
          width: '480px',
          borderRadius: '24px',
          padding: 0,
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column',
          maxHeight: '90vh'
        }
      }}
      open
    >
      <Stack sx={{ height: '100%', display: 'flex', flexDirection: 'column', flex: 1, overflow: 'hidden' }}>
        <ModalHeader
          icon={<i className={`fa-light fa-${item ? 'pen' : 'plus'}`} />}
          subtitle={item ? t('event_ssids.modal.update') : t('event_ssids.modal.create')}
          title={item ? item.label : t('event_ssids.modal.new_event')}
          onClose={handleClose}
        />
        {children}
      </Stack>
    </Dialog>
  )
}

export default Modal